// Helper to map product_type to URL segment
export function getProductUrlSegment(productType: string): string {
  const type = productType?.toLowerCase() || '';
  
  if (['ma', 'ms', 'pdp', 'medicare', 'medicare_advantage'].includes(type)) {
    return 'medicare';
  }
  if (['aca', 'aca_health'].includes(type)) {
    return 'aca';
  }
  if (['life', 'fe', 'life_insurance', 'final_expense'].includes(type)) {
    return 'life';
  }
  if (['private', 'private_health'].includes(type)) {
    return 'private';
  }
  if (['ancillary'].includes(type)) {
    return 'ancillary';
  }
  
  // Default to medicare if unknown
  return 'medicare';
}

// Helper to navigate to contact detail
export function navigateToContact(navigate: (path: string) => void, contactId: string, productType: string) {
  const segment = getProductUrlSegment(productType);
  navigate(`/contacts/${contactId}/${segment}`);
}
